import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "reactstrap";
import SpinnerComponent from "../../../@core/components/spinner/Fallback-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "../../../assets/scss/account/profile.scss";
import Repository from "@src/configs/axios/repository";
import { useDispatch } from "react-redux";
import clear from "../../../assets/images/account/clear.png";
import copy from "../../../assets/images/account/copy-regular.svg";
import warning from "../../../assets/images/account/warning.svg";
import CryptoJS from "crypto-js";
import { handleLogout } from "../../../redux/authentication";
import { handlePlanState } from "../../../redux/layout";
import Swal from "sweetalert2";
import Modal from "react-modal";
const customStyles = {
    content: {
        top: "50%",
        left: "55%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "30px 40px",
        width: "450px",
        zIndex: "9000",
    },
};

const Settings = (props) => {
    const copyLinkRef = useRef(null);
    const [loadingData, setLoadingData] = useState(true);
    const [isResult, setIsResult] = useState(false);
    const [isSubscription, setIsSubscription] = useState(false);
    const [findUser, setFindUser] = useState("");
    const dispatch = useDispatch();
    const [showUserNameClear, setShowUserNameClear] = useState(false);
    const [phoneValue, setPhoneValue] = useState("");
    const [subscription, setSubscription] = useState("");
    const [card, setCard] = useState("");
    const [subscriptionId, setSubscriptionId] = useState("");
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    let planState = localStorage.getItem("planState");
    const handleClear = (formik, nameFild) => {
        if (nameFild == "user_name") {
            formik.setFieldValue("user_name", "");
        } else if (nameFild == "last_name") {
            formik.setFieldValue("last_name", "");
        }
    };
    function closeModal() {
        setIsOpen(false);
    }

    const getUserInfo = async () => {
        setLoadingData(false);
        const result = await Repository.findByEndPoint(
            `api/users/findThisUser`
        );

        if (
            result.data?.success === true &&
            (result.data.data?.plan_state == "active" ||
                result.data.data?.plan_state == "trialing")
        ) {
            setFindUser(result.data.data);
            setPhoneValue(result.data.data.phone_number);
            setIsSubscription(true);
            const response = await Repository.findByEndPoint(
                `api/stripe/retrieveSubscription/${result.data.data.stripe_subscription_id}`
            );

            if (response.data?.success) {
                setSubscriptionId(result.data.data.stripe_subscription_id);
                const responseCard = await Repository.findByEndPoint(
                    `api/stripe/listCustomerCards/${response.data.data.customer}`
                );
                setCard(responseCard.data.data.data[0]);
               
                setSubscription(() => {
                    return {
                        amount: response.data.data?.plan?.amount,
                        interval: response.data.data.plan.interval,
                        status: response.data.data.status,
                    };
                });
            }
            setIsResult(true);
            setLoadingData(true);
        } else {
            setIsSubscription(false);
            setIsResult(true);
            setFindUser(result.data.data);
            setLoadingData(true);
        }
        setLoadingData(true);
    };
    const updateUserInfo = async (values) => {
        delete values.email;

        const result = await Repository.updateData(
            `api/users/updateUserInfo`,
            values
        );
        if (result.data.success === true) {
            getUserInfo();

            Swal.fire({
                position: "center",
                title: "Your profile has been successfully save.",
                icon: "success",
                confirmButtonColor: "#16285e",
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
            });
        }
    };

    const deactivate = async () => {
        setIsChecked(false);
        const result = await Repository.deleteById(`api/users/deactivate`);
        if (result.data.success === true) {
            setIsOpen(false);
            Swal.fire({
                title: "Your account has been deactivated.",
                icon: "success",
                confirmButtonColor: "#16285e",
            }).then(() => {
                dispatch(handleLogout());
            });
        }
    };

    const cancelSubscription = async (values) => {
        Swal.fire({
            text: "Are you sure you want to cancel your subscription?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const result = await Repository.deleteById(
                    `api/users/cancelSubscription/${subscriptionId}`
                );
                if (result.data.success === true) {
                    localStorage.setItem("planState", "none");
                    localStorage.setItem("planState", "canceled");
                    dispatch(handlePlanState("canceled"));
                    return "Subscription canceled.";
                } else {
                    Swal.showValidationMessage(
                        "Cancel failed. Please try again."
                    );
                }
            },
        }).then((result) => {
            if (
                result.isConfirmed &&
                result.value === "Subscription canceled."
            ) {
                localStorage.setItem("planState", "canceled");

                setIsSubscription(false);
            }
        });
    };

    const handleCopyLink = () => {
        const range = document.createRange();
        const selection = window.getSelection();

        range.selectNode(copyLinkRef.current);
        selection.removeAllRanges();
        selection.addRange(range);

        document.execCommand("copy");
        selection.removeAllRanges();

        setAlertVisible(true);

        setTimeout(() => {
            setAlertVisible(false);
        }, 6000);
    };
    const md5 = (input) => {
        return CryptoJS.MD5(input).toString(CryptoJS.enc.Hex);
    };

    useEffect(() => {
        getUserInfo();
    }, [planState]);

    return loadingData ? (
        <div className="profileSettings">
            <div className="profileHeader">
                <h1>Profile Details</h1>
            </div>
            <div className="profileDetalis">
                <div className="formProfile">
                    <Formik
                        initialValues={{
                            user_name: findUser?.user_name,
                            email: findUser?.email,
                        }}
                        validate={(values) => {
                            const errors = {};

                            if (values.user_name) {
                                setShowUserNameClear(true);
                            }

                            if (!values.user_name) {
                                setShowUserNameClear(false);

                                errors.user_name = "User name is required.";
                            }

                            // if (phoneValue == "") {
                            //     errors.phone_number =
                            //         "Phone number is required.";
                            // }

                            return errors;
                        }}
                        onSubmit={(values) => {
                            updateUserInfo(values);
                        }}
                    >
                        {(formik) => (
                            <Form className="formikEvents">
                                <Row>
                                    <Col xl="6" md="6" sm="12">
                                        <div className="labelInputs">
                                            Full Name
                                        </div>
                                        <Field
                                            className="formikInput"
                                            type="text"
                                            name="user_name"
                                            placeholder="Full Name"
                                        />

                                        <div className="viewIcon">
                                            {showUserNameClear ? (
                                                <img
                                                    onClick={() => {
                                                        handleClear(
                                                            formik,
                                                            "user_name"
                                                        );
                                                    }}
                                                    src={clear}
                                                    alt="clear"
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                        <ErrorMessage
                                            className="errorMessage"
                                            name="user_name"
                                            component="div"
                                        />
                                    </Col>
                                    <Col xl="6" md="6" sm="12">
                                        <div className="labelInputs">Email</div>
                                        <Field
                                            className="formikInput"
                                            type="text"
                                            name="email"
                                            placeholder="Email"
                                            disabled={true}
                                        />
                                        {/* <div className="labelInputs">
                                            Phone Number
                                        </div> */}
                                        {/* <PhoneInput
                                            international
                                            placeholder="Enter phone number"
                                            value={phoneValue}
                                            onChange={setPhoneValue}
                                        />
                                        <ErrorMessage
                                            className="errorMessage "
                                            name="phone_number"
                                            component="div"
                                        /> */}
                                    </Col>

                                    <Col xl="12" md="12" sm="12">
                                        <div className="modalBtn">
                                            <button
                                                type="submit"
                                                className="btnUpdate"
                                            >
                                                Save Changes
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="addAndCloseDivEvents">
                    <div className="d-flex justify-content-center">
                        <img src={warning} alt="warning" />
                    </div>
                    <div className="d-flex justify-content-center mt-4">
                        <h1>Are you sure?</h1>
                    </div>
                    <div className="d-flex justify-content-center deactivateContent mt-2">
                        <p>
                            Deactivating your account will result in the
                            permanent loss of your subscription, courses,
                            flashcards, tests, and other content. Are you sure
                            you want to delete your account?
                        </p>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <input
                            type="checkbox"
                            id="confirmationCheckbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        <label for="confirmationCheckbox">Yes, I agree.</label>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="d-flex">
                            <button
                                className="deactivate"
                                disabled={!isChecked}
                                onClick={() => {
                                    deactivate();
                                }}
                            >
                                Yes, deactivate!
                            </button>
                            <button
                                className="cancelBtn"
                                onClick={() => {
                                    setIsOpen(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* 
            <div>
                <div className="profileHeader deleteAccount">
                    <h1>Affiliate Code</h1>
                </div>
                <div className="deleteDetalis ">
                    <div className="paymentInfo">
                        <div className="paymentInfoContent copyLink">
                            <div>
                                <span ref={copyLinkRef} className="copyLink ">
                                    {`https://account.smart-study.ai/register?lead_source=%7B${md5(
                                        findUser.user_id
                                    )}%7D`}
                                </span>
                                <img
                                    onClick={handleCopyLink}
                                    src={copy}
                                    alt="copy"
                                    style={{ cursor: "pointer" }}
                                />
                            </div>
                            {alertVisible && (
                                <div
                                    style={{
                                        marginTop: "8px",
                                        transition: "opacity 5s",
                                        color: "#3989d9",
                                    }}
                                >
                                    Link copied!
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div> */}

            {isSubscription ? (
                <div>
                    <div className="profileHeader deleteAccount">
                        <h1>Subscription</h1>
                    </div>
                    <div className="deleteDetalis ">
                        <div className="paymentInfo">
                            <div className="paymentInfoContent">
                                <div>
                                    <p>
                                        <p
                                            style={{
                                                textTransform: "capitalize",
                                                marginBottom: "1px",
                                            }}
                                        >
                                            {subscription?.interval == "month"
                                                ? "Monthly"
                                                : "Yearly"}{" "}
                                            Subscription{" "}
                                            {`(${findUser.stripe_subscription_type})`}{" "}
                                            - $ {subscription?.amount / 100}
                                        </p>
                                        <span>
                                            {subscription?.interval == "month"
                                                ? " Gain unlimited access written exams, combination tests, a real-time feedback system plus all additional Smart Study features!"
                                                : "Save money by accessing Smart Study premium for an entire year!"}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="deleteAccountSubmit">
                            <button
                                type="button"
                                onClick={() => {
                                    cancelSubscription();
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}
            <div className="profileHeader deleteAccount">
                <h1>Delete Account</h1>
            </div>
            <div className="deleteDetalis ">
                <div className="delAccContent">
                    <h4>Are you sure you want to delete your account?</h4>
                    <p>
                        Permanently delete your account and all study materials.
                    </p>
                </div>
                <div className="deleteAccountSubmit">
                    <button
                        type="button"
                        onClick={() => {
                            setIsOpen(true);
                        }}
                    >
                        Deactivate Account
                    </button>
                </div>
            </div>
        </div>
    ) : (
        <SpinnerComponent spiner={true} />
    );
};

export default Settings;
